import { Event } from "../../pojo/Event";

export const EventStateConst = {
    updateState: "s25-event-state-update-state",
    stateMap: {
        0: "Draft",
        1: "Tentative",
        2: "Confirmed",
        3: "Sealed",
        98: "Denied",
        99: "Cancelled",
    } as { [key: number]: string },
    transitionMap: {
        0: { 0: true, 1: true, 2: true, 3: true, 98: true, 99: true },
        1: { 0: true, 1: true, 2: true, 3: true, 98: true, 99: true },
        2: { 0: true, 1: true, 2: true, 3: true, 98: true, 99: true },
        3: { 0: true, 1: true, 2: true, 3: true, 98: true, 99: true },
        98: { 0: true, 1: true, 2: true, 3: true, 98: true, 99: true },
        99: { 0: true, 1: true, 2: true, 3: true, 98: true, 99: true },
    },
    warningMap: {
        3: "sealed_warning",
        98: "denied_warning",
        99: "cancelled_warning",
    },
    allEventStates: [
        Event.State.Ids.Draft,
        Event.State.Ids.Tentative,
        Event.State.Ids.Confirmed,
        Event.State.Ids.Sealed,
        Event.State.Ids.Denied,
        Event.State.Ids.Cancelled,
    ],
};
